<template>
  <b-tooltip :label="!bed.patient_id ? 'Cambiar estado de la cama' : 'Cama ocupada'" type="is-dark">
    <b-button :disabled="bed.patient_id" type="is-warning" size="is-small" @click="changeStateBed" icon-left="sync-alt" :loading="loading">
    </b-button>
  </b-tooltip>
</template>
<script>
  import { GetBed, PutBed } from "../../services/beds";
  import { eventBus } from "../../main";
  export default {
    props: ["bed"],
    data() {
      return {
        loading: false,
      };
    },
    methods: {
      async changeStateBed() {
        this.$buefy.dialog.confirm({
          title: "Cambiar estado de la cama",
          message: `¿Desea cambiar el estado de la cama a <b>${this.bed.state == "HABILITADA" ? "BLOQUEADA" : "HABILITADA"
            }</b>?`,
          confirmText: "Cambiar Estado",
          type: "is-warning",
          hasIcon: true,
          onConfirm: async () => {
            this.loading = true;
            try {
              let response = await GetBed(this.$http, this.bed.id);
              let data = {
                ...response,
                state:
                  this.bed.state == "HABILITADA" ? "BLOQUEADA" : "HABILITADA",
              };
              await PutBed(this.$http, this.bed.id, data);
              eventBus.$emit("loadBedList");
              this.$buefy.toast.open({
                message: "Estado modificado sin problemas",
                type: "is-success",
              });
            } catch (err) {
              this.$buefy.toast.open({
                message: "Error al cambiar el estadd",
                type: "is-danger",
              });
            }
            this.loading = false;
          },
        });
      },
    },
  };
</script>